import { concatClasses } from "../../../helpers/concatClasses/index.js";
import "../../atom/Icon/index.js";
import "../Badge/index.js";
const getOptionClasses = ({ disabled, dsf_selected, dsf_active }) => {
  const classes = [
    "font-sans",
    "dsf-text-s",
    "flex",
    "flex-auto",
    "items-center",
    "px-12",
    "py-8",
    "truncate"
  ];
  classes.push(disabled ? "cursor-not-allowed" : "cursor-pointer");
  if (disabled) {
    classes.push("bg-neutral-50");
  } else if (dsf_active) {
    classes.push("bg-secondary-100");
  } else if (dsf_selected) {
    classes.push("bg-secondary-50");
  } else {
    classes.push("bg-neutral-0");
  }
  classes.push("hover:bg-neutral-50");
  if (disabled) {
    classes.push("text-neutral-400");
  } else if (dsf_selected) {
    classes.push("text-secondary-300");
  }
  return concatClasses(classes);
};
export {
  getOptionClasses
};
